import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type WithConfirmType = ((cancelCallback: () => void) => void) | null;

export const navigationSlice = createSlice({
  name: "navigation",
  initialState: {
    withConfirm: null as WithConfirmType,
  },
  reducers: {
    setWithConfirm: (state, action: PayloadAction<WithConfirmType>) => {
      state.withConfirm = action.payload;
    },
    removeWithConfirm: (state) => {
      state.withConfirm = null as WithConfirmType;
    },
  },
});

export const { setWithConfirm, removeWithConfirm } = navigationSlice.actions;

export default navigationSlice.reducer;
